export const PERMISSIONS = {
	BRAND_MANAGER: 'Brand Manager', // id is 4
	SUPER_ADMIN: 'Super Admin', // id is 5
	ADMIN: 'Admin', // id is 6
}

export const IS_INTERNAL = process.env.REACT_APP_IS_INTERNAL === 'true'
